import { useDispatch, useSelector } from 'react-redux';

import PropTypes from 'prop-types';
import { getFormValues } from 'redux-form';

import { useTransl } from 'shared/lib/i18n';

import ModalHandlerComponent from '../../Modal/ModalHandlerComponent';
import BanMemberComponent from './BanMemberComponent';

import { banMember, getCommunityMembersForFilter } from '../actions';

import { getPersonFilterOptions } from '../../Amenity/utils';

import { CUSTOM } from '../../Modal/modalTypes';

const form = 'BanMember';

const BanMemberContainer = ({ onModalClose, communityId }) => {
  const { t } = useTransl();
  const dispatch = useDispatch();
  const store = useSelector((state) => state);
  const formValues = getFormValues(form)(store);

  const { community } = store;

  const membersOptions = getPersonFilterOptions(
    community?.communityMembersListForFilter,
  );

  const onLoad = () =>
    getCommunityMembersForFilter(dispatch, {
      community: communityId,
      disable_pagination: true,
    });

  const onSubmit = () => {
    const { personId, comment } = formValues;

    banMember(dispatch, communityId, personId, { comment }).then((response) => {
      if (response) onModalClose();
    });
  };

  const initialValues = {
    comment: null,
  };

  return (
    <ModalHandlerComponent
      modal={{
        modalType: CUSTOM,
        modalProps: {
          title: t('community.banPerson'),
        },
      }}
      onModalClose={onModalClose}
    >
      <BanMemberComponent
        membersOptions={membersOptions}
        onLoad={onLoad}
        onSubmit={onSubmit}
        initialValues={initialValues}
      />
    </ModalHandlerComponent>
  );
};

BanMemberContainer.propTypes = {
  onModalClose: PropTypes.func.isRequired,
  communityId: PropTypes.number.isRequired,
};

export default BanMemberContainer;
